import {Component, EventEmitter, Input} from '@angular/core';

import {timer} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';

import {ClipboardService} from 'ngx-clipboard';
import {Destroyable} from '../../../destroyable.component';

@Component({
  selector: 'gp-api-error-modal',
  templateUrl: './api-error-modal.component.html',
  styleUrls: ['./api-error-modal.component.css']
})
export class ApiErrorModalComponent extends Destroyable {

  @Input()
  public type: 'DANGER' | 'WARNING';

  @Input()
  public title = 'Server Error';

  @Input()
  public titleIcon = 'fa-circle-exclamation';

  @Input()
  public description = 'An error occurred while processing your request. Please try again later.';

  @Input()
  public details: string[];

  @Input()
  public technicalDetailsForCopy: string;

  @Input()
  public withIllustration = false;

  public result: EventEmitter<void> = new EventEmitter<void>();

  public isCopied = false;

  constructor(private clipboardService: ClipboardService) {
    super();
  }

  public done() {
    this.result.emit(undefined);
    this.result.complete();
  }

  public copyToClipboard(): void {
    this.clipboardService.copy(this.technicalDetailsForCopy || '');

    this.isCopied = true;

    timer(3000).pipe(
      tap(() => {
        this.isCopied = false;
      }),
      takeUntil(this.componentDestroyed$)
    ).subscribe();
  }

  public noDetails(): boolean {
    return !this.details || this.details.length <= 0;
  }
}
